import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { AppIdentifiers } from '../store/slices/token-state.slice';

/**
 * Whether this account may opt into the Lifetime release channel. Set on the
 * JWT at login from the Kartra "CH Lifetime Deal" tag or a manual grant.
 */
export function useIsLifetimeMember(): boolean {
  const token = useSelector(
    (state: RootState) => state.tokenState[AppIdentifiers.App],
  );

  return useMemo(() => {
    try {
      if (!token?.accessToken || typeof token.accessToken !== 'string') {
        return false;
      }
      const payload = JSON.parse(atob(token.accessToken.split('.')[1]));
      return payload?.lifetimeMember === true;
    } catch {
      return false;
    }
  }, [token?.accessToken]);
}
